import React, { useState } from "react";
import { useCreateProviderUser } from "../custom-hooks/queries";
import CustomButton from "./CustomButton";

export const AddProviderUserForm = ({ onClose }) => {
  const [formData, setFormData] = useState({
    email: "",
    first_name: "",
    last_name: "",
    company_url: "",
    phone_number: "",
    office_phone_number: "",
    contact_preference: "Office_Phone",
    provider_id: "",
  });

  const createUser = useCreateProviderUser();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await createUser.mutateAsync(formData);
      onClose();
    } catch (error) {
      console.error("Error creating user:", error);
    }
  };

  return (
    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg p-6 max-w-md w-full">
        <h2 className="text-lg font-semibold mb-4">Add New Provider User</h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Email
            </label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              First Name
            </label>
            <input
              type="text"
              name="first_name"
              value={formData.first_name}
              onChange={handleChange}
              required
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              Last Name
            </label>
            <input
              type="text"
              name="last_name"
              value={formData.last_name}
              onChange={handleChange}
              required
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              Company URL
            </label>
            <input
              type="url"
              name="company_url"
              value={formData.company_url}
              onChange={handleChange}
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              Phone Number
            </label>
            <input
              type="tel"
              name="phone_number"
              value={formData.phone_number}
              onChange={handleChange}
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              Office Phone Number
            </label>
            <input
              type="tel"
              name="office_phone_number"
              value={formData.office_phone_number}
              onChange={handleChange}
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              Contact Preference
            </label>
            <select
              name="contact_preference"
              value={formData.contact_preference}
              onChange={handleChange}
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
            >
              <option value="Office_Phone">Office Phone</option>
              <option value="Mobile_Phone">Mobile Phone</option>
              <option value="Email">Email</option>
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              Provider ID
            </label>
            <input
              type="text"
              name="provider_id"
              value={formData.provider_id}
              onChange={handleChange}
              required
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
            />
          </div>

          <div className="flex justify-end space-x-4 mt-6">
            <CustomButton
              color="bg-gray-200"
              size="text-sm"
              weight="font-normal"
              height="h-8"
              width="w-20"
              textColor="text-gray-700"
              text="Cancel"
              borderRadius="0.375rem"
              onClick={onClose}
            />
            <CustomButton
              color="bg-indigo-600"
              size="text-sm"
              weight="font-normal"
              height="h-8"
              width="w-20"
              textColor="text-white"
              text="Save"
              borderRadius="0.375rem"
              type="submit"
            />
          </div>
        </form>
      </div>
    </div>
  );
};
